// client/src/components/layout/PageScrollRestoration.tsx (ST-00087)
//
// Mount once inside each router whose pages scroll in `paneRef` (the untabbed shell's
// .page-pane, or a tab's pane). New pages open at the top; Back / Forward returns to where the
// page was left. See hooks/usePageScrollRestoration.ts for the rules.
import type { RefObject } from 'react';
import usePageScrollRestoration from '../../hooks/usePageScrollRestoration';

export default function PageScrollRestoration({
  paneRef,
}: {
  paneRef: RefObject<HTMLElement | null>;
}): null {
  usePageScrollRestoration(paneRef);
  return null;
}
